import { useMotivationToCategoriesMap } from './useCategorySelections'

type TCategory = { id: number; name: string; slug: string }

export const useOptionalCategory = (category?: TCategory) => {
  const motivationToCatName = useMotivationToCategoriesMap()

  if (!category) return { isOptionalCategory: false }

  const isOptionalCategory = motivationToCatName.other?.includes(
    category?.name as (typeof motivationToCatName.other)[number],
  )

  return { isOptionalCategory }
}
